import type { User } from '@halo/chat-sdk';

type Contact = User;

export interface ContactsListProps {
  contacts: Contact[];
  /** Required when onContactSelect is provided */
  selectedContacts?: Contact[];
  className?: string;
  onContactSelect?: (contacts: Contact[]) => void;
  onContactClick?: (contact: Contact) => void;
  showAlphabetIndex?: boolean;
  isPage?: boolean;
}

export interface GroupedContacts {
  [key: string]: Contact[];
}

export const groupContactsByFirstLetter = (contacts: Contact[]): GroupedContacts => {
  return contacts.reduce((groups: GroupedContacts, contact) => {
    const firstChar = contact.name.charAt(0).toUpperCase();
    const firstLetter = /[A-Z]/.test(firstChar) ? firstChar : '#';
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(contact);
    return groups;
  }, {});
};

export const flatGroupedContacts = (originalData: GroupedContacts) => {
  const transformedArray: any[] = [];

  Object.keys(originalData).forEach((groupKey) => {
    transformedArray.push({
      name: groupKey,
      isGroupKey: true,
    });

    originalData[groupKey].forEach((member) => {
      transformedArray.push({
        ...member,
      });
    });
  });
  return transformedArray;
};

export const sortGroupedContacts = (groupedContacts: GroupedContacts): GroupedContacts => {
  const sortedGroups: GroupedContacts = {};
  Object.keys(groupedContacts)
    .sort((a, b) => {
      if (a === '#') return 1;
      if (b === '#') return -1;
      return a.localeCompare(b);
    })
    .forEach((letter) => {
      sortedGroups[letter] = groupedContacts[letter].sort((a, b) => a.name.localeCompare(b.name));
    });
  return sortedGroups;
};

export const generateAlphabetList = (): string[] => {
  return Array.from(Array(26)).map((_, i) => String.fromCharCode(65 + i));
};
